/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { RegionInfo } from '@modules/cloud-api/v1/types'
import type { WithRouterProps } from '@modules/routing/withRouter'
import withRouter from '@modules/routing/withRouter'

import { getRegionInfo } from '@/reducers/platform'

import Hosts from './Hosts'

import type { ReduxState } from '@/types/redux'

type HostsType = 'allocators' | 'proxies' | 'control-planes'

type StateProps = {
  regionId: string
  regionInfo: RegionInfo | null
}

type DispatchProps = unknown

type ConsumerProps = WithRouterProps<{
  regionId: string
}> & { hostsType?: HostsType }

const mapStateToProps = (
  state: ReduxState,
  {
    router: {
      params: { regionId },
    },
  }: ConsumerProps,
): StateProps => ({
  regionId,
  regionInfo: getRegionInfo(state, regionId),
})

const mapDispatchToProps: DispatchProps = {}

export default withRouter(
  connect<StateProps, DispatchProps, ConsumerProps>(mapStateToProps, mapDispatchToProps)(Hosts),
)
